export default function myImageLoader(allProps: any) {
  const { src, width, quality } = allProps;
  const format = allProps.format || "webp";

  // only modify the url if src is /api/file
  if (!src.startsWith("/api/file")) {
    return src;
  }
  let url: string = src;
  if (width) {
    url += `?w=${width}`;
  }

  if (quality) {
    url += `&q=${quality}`;
  }

  if (format) {
    url += `&format=${format}`;
  }

  return url;

  // return `${process.env.API_URL}/?w=${width}&q=${quality || 75}`;
}
